export const getTitle = (model: {
    name?: string;
    productTitle?: string;
    articleConfiguration?: {
        title?: string;
    } | null;
}) => {
    if (model.articleConfiguration) {
        return model.articleConfiguration.title || "";
    }

    return model.productTitle || model.name || "";
};
